// extracted by mini-css-extract-plugin
export default {"container":"UserDisplay_container__jnRCH","identicon":"UserDisplay_identicon__5YzwN"};